import React, { Component } from 'react';
import { FROM } from '../../util/enums/EnumLayers';

class ModalFrom extends Component {
  static modalType() {
    return FROM;
  }

  static reducer(modals) {
    return modals.fromModal;
  }

  static title() {
    return 'Starting from Table';
  }

  render() {
    const { state, userInteraction } = this.props;

    const selected = state.selected && (
      <span>
        Start from{' '}
        <button
          type="button"
          className="btn btn-outline-dark"
          onClick={userInteraction({ section: 'reset' })}
        >
          <b>{state.selected.name()}</b>{' '}
          {state.selected.schema() === 'public' ? null : (
            <span className="faint">{state.selected.schema()}</span>
          )}
        </button>{' '}
        table
      </span>
    );

    const tables = selected
      ? null
      : state.tables.map((t, index) => (
          <a
            onClick={userInteraction({ section: 'selected', table: t })}
            key={index}
            href="#"
            className="list-group-item"
          >
            <b>{t.name()}</b>{' '}
            {t.schema() === 'public' ? null : (
              <span className="faint">{t.schema()}</span>
            )}
          </a>
        ));
    return (
      <div>
        {selected}
        <div className="list-group">{tables}</div>
      </div>
    );
  }
}

export default ModalFrom;
